var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({attrs:{"disabled":_vm.loading || _vm.$attrs.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"fa fa-spin",class:{ 'fa-circle-notch': _vm.loading }}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }